import { render } from "./TagFilter.vue?vue&type=template&id=8d4082fe&scoped=true&ts=true"
import script from "./TagFilter.vue?vue&type=script&lang=ts"
export * from "./TagFilter.vue?vue&type=script&lang=ts"

import "./TagFilter.vue?vue&type=style&index=0&id=8d4082fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4082fe"]])

export default __exports__